import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import DownloadPage from '../views/DownloadPage.vue'
import CourseSharePage from '../views/CourseSharePage.vue'
import TeacherSharePage from '../views/TeacherSharePage.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/download',
    name: 'download',
    component: DownloadPage,
  },
  {
    path: '/course/:id',
    name: 'course-share',
    component: CourseSharePage,
  },
  {
    path: '/teacher/:id',
    name: 'teacher-share',
    component: TeacherSharePage,
  },
]

const router = createRouter({
  // OSS/CDN 对 /course/:id 会 404，微信抓不到页就不出卡片；
  // Hash 模式实际请求始终是站点根路径，保证 200 + OG meta。
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
